import { combineReducers, createStore } from "redux";
import followupJobReducer from "./reducers/follow-up-reducer";
export default createStore(
    combineReducers({
        followup: followupJobReducer
    }),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);